"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
class PopoverArrow extends _react.default.Component {
  constructor(props) {
    var _context, _context2;
    super(props);
    this.getArrowOffset = (0, _bind.default)(_context = this.getArrowOffset).call(_context, this);
    this.getClip = (0, _bind.default)(_context2 = this.getClip).call(_context2, this);
  }

  // This positions the arrow so it's center-aligned with the anchor
  getArrowOffset() {
    if (!this.props.anchorEl) {
      return '0px';
    }
    let boundingRectangle = this.props.anchorEl.getBoundingClientRect();
    let center = (boundingRectangle.left + boundingRectangle.right) / 2;
    return center - this.props.arrowHeight + 'px';
  }

  // This clips the bottom half of the rotated square to make it arrow shaped,
  // or clips more off the bottom if there isn't space between the anchor and
  // the popover
  getClip() {
    let height = this.props.arrowHeight - this.props.arrowGap;
    let width = this.props.anchorEl ? this.props.anchorEl.offsetWidth : 0;

    // This handles the case when the popover is at the bottom of the screen
    // Material-UI deals with this by pushing up the popover, so we want to
    // remove any of the arrow that overlaps the popover
    if (this.props.popoverEl && this.props.anchorEl) {
      let calc = this.props.popoverEl.getBoundingClientRect().top - this.props.anchorEl.getBoundingClientRect().bottom;
      calc = calc * 2; // There's a scale difference between getBoundingClientRect and clip
      calc = calc - this.props.arrowHeight;
      calc = calc - this.props.arrowGap;
      height = Math.min(height, calc);
    }
    return 'rect(' +
    // Add extra space for the blur
    -1 * this.props.arrowHeight + 'px, ' + width + 'px, ' + height + 'px, ' + -1 * this.props.arrowHeight + 'px' + ')';
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_styles.DummyArrowWrap, {
      "data-testid": this.props['data-testid'],
      arrowGap: this.props.arrowGap + 'px',
      clip: this.getClip(),
      leftOffset: this.getArrowOffset()
    }, /*#__PURE__*/_react.default.createElement(_styles.DummyArrow, {
      elevation: this.props.elevation,
      open: this.props.open,
      arrowSideLength: this.props.arrowSideLength + 'px'
    }));
  }
}
var _default = exports.default = PopoverArrow;
PopoverArrow.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getArrowOffset",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "getClip",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "PopoverArrow"
};